import CardsViewContainer from "../../../components/miscellaneous/jobSearch/cardsView";

const CardsView = () => {
  return <CardsViewContainer />;
};

export default CardsView;
